module.exports = __webpack_public_path__ + "static/media/bobWessels.47810917.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/bobWessels.jpg
// module id = 1669
// module chunks = 1